<template>
  <div class="left_nav">
    <Menu>
      <Submenu  v-show="item.checked"  :key="index" v-for="(item, index) in navData" :name="index" >
        <template slot="title">
          <!--<Icon type="ios-paper"></Icon>-->
          <!--<img src="../assets/nav_icon/info_icon.png" style="width: 21px;height: 21px;" alt="">-->
          <i :class=item.icon></i>
          <!--<i class='iconfont icon-baocanguanli'></i>-->
          <!--<i class='iconfont icon-renyuanxuanze'></i>-->
          <!--<i class='iconfont icon-xinxifabuyujieshou'></i>-->
          {{item.title}}
        </template>
        <Menu-item v-show="item2.checked" @click.native="clickFn(item2.path)" :key="index2" v-for="(item2, index2) in item.children" :class="(index+1)+'-'+(index2+1)" :name="index+'-'+index2">
            {{item2.title}}
        </Menu-item>
      </Submenu>
    </Menu>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["user", "num", "token"]),
    ...mapGetters(["filterUser"])
  },
  data() {
    return {
      theme2: 'light',
      navData: [
        {
          title: '用户管理',
          children: [
            {
              title: '角色管理',
              path: '/role'
            },
            {
              title: '用户管理',
              path: '/info'
            },
            {
              title: '部门管理',
              path: '/depart'
            }
          ]
        },
        {
          title: '就餐管理',
          children: [
            {
              title: '就餐统计',
              path: '/dinnerState'
            },
            {
              title: '就餐记录',
              path: '/dinnerMonth'
            },
            {
                title: '就餐设置',
                path: '/mealSetting'
            },
            {
                title: '菜单编辑',
                path: '/menus'
            },
            {
                title: '大屏设置',
                path: '/order'
            },

          ]
        },
        {
          title: '信息管理',
          children: [
            {
              title:'信息列表',
              path: '/infoList'
            }
          ]
        },
        {
          title: '资产管理',
          children: [
              {
                  title: '资产信息列表',
                  path: '/asetsList'
              },
              {
                  title: '借出记录',
                  path: '/lendRecord'
              },
              {
                  title: '调拨记录',
                  path: '/allocationRecord'
              },
              {
                  title: '报废记录',
                  path: '/scrapRecord'
              }
          ]
        }
      ]
    }
  },
  components: {

  },
  methods: {
      clickFn(a){
        var str = '/data'+a;
        this.$router.push(str);
      },
      getLeft(){
        var that = this;
        var params = {
          data: {
            "username" : window.localStorage.getItem("userName")
          },
          token: "swgykj9527",
          url: '/sys/menus/getusermenus',
          success: (res) => {
              console.log(res);
              that.navData  = res.data.result.menus;
          }
        }
        this.ajaxPost(params)
      },
//      changeImg(){
//
//          console.log(event.target.innerText);
//          console.log(event);
//          console.log(this);
//          console.log($(this));
//          if(event.target.innerText==' 资产管理'){
//              console.log(7777777);
//              console.log($(event.target.innerHTML));
//
//          }
//
//      },
    ...mapMutations(["SET_USER","SET_TOKEN"])
  },
  mounted(){
      this.getLeft();
//      var that=this;
//      $('.ivu-menu-submenu-title').bind('click',function(){
////          that.changeImg()
//          console.log($(this));
//          console.log($(this)[0].innerText==' 资产管理');
//          if($(this)[0].innerText==' 资产管理'){
//              console.log(77777);
//
//              $(this).children("img").attr("src","../assets/nav_icon/meal_icon.png");
////              this.innerHTML='<img src="../assets/nav_icon/meal_icon.png" style="width: 21px;height: 21px;" alt="">资产管理'
//          }
////          this.innerHTML='<div>6666</div>'
//      })
  }
}
</script>

<style lang="scss" scoped>
  @import "../global/font/iconfont.css";
  .left_nav{
    .ivu-menu-opened{

    }
  }
</style>




// WEBPACK FOOTER //
// src/components/leftNav.vue